import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services'
var localizedData = [];
class myDropDownCellOrigemPagamento extends Component {

  componentDidMount() {
    (async () => {
      const data = {}
      const ArtigosService = await services.apiCall.requestApi(
        "/Receita/GetPenhoraTipoOrigemValor",
        data,
        "get"
      );
      if (localizedData.length == 0 ){
        ArtigosService.map((tipo) => (
          localizedData.push({text: tipo.penhoraTipoOrigemValor, value: tipo.idPenhoraTipoOrigemValor})
  
        ));
      }
      console.log("AQUI")
    })();
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={localizedData}
              textField="text"
              id='id-DropDownCellTipoOrigemValor'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
    
}

export default myDropDownCellOrigemPagamento;
